import { useCustomDeleteDailyFormVehiclePartMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteDailyFormVehiclePart() {
  const [mutation, { loading, data, error }] = useCustomDeleteDailyFormVehiclePartMutation();

  const [deleteDailyFormVehiclePart, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteDailyFormVehiclePart",
    },
    { hideMessage: true }
  );

  return [deleteDailyFormVehiclePart, context] as const;
}
